import { defaultClientV2, apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

export const move = async (fleetTaskId, pointId, activityId, type) =>
  defaultClientV2({
    method: 'POST',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/point/${pointId}/activity/${activityId}/movement`,
    data: {
      type,
    },
  })

export const getAttachments = (fleetTaskId, pointId, activityId) => {
  return defaultClientV2({
    method: 'GET',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/point/${pointId}/activity/${activityId}/attachment`,
  })
}

export const uploadAttachment = async (fleetTaskId, pointId, activityId, data) => {
  const formData = new FormData()
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, value)
  }

  const res = await apiClientV2.post(
    `/fleet-task/${fleetTaskId}/point/${pointId}/activity/${activityId}/attachment`,
    formData,
    {
      method: 'POST',
      baseURL,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  return res?.data
}

export const deleteAllAttachments = (fleetTaskId, pointId, activityId) => {
  return defaultClientV2({
    method: 'DELETE',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/point/${pointId}/activity/${activityId}/attachment`,
  })
}

export const complete = (fleetTaskId, pointId, activityId, data) => {
  return defaultClientV2({
    method: 'POST',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/point/${pointId}/activity/${activityId}/complete`,
    data,
  })
}

export const getActivity = (fleetTaskId, deliveryOrderId) => {
  return defaultClientV2({
    method: 'GET',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/delivery-order/${deliveryOrderId}/activity`,
  })
}

export const adjustLoad = (fleetTaskId, pointId, activityId, data) => {
  return defaultClientV2({
    method: 'PATCH',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/point/${pointId}/activity/${activityId}/adjust-load`,
    data,
  })
}

export const bulkActivityCompletion = (fleetTaskId, data) => {
  return defaultClientV2({
    method: 'PUT',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/completion`,
    data,
  })
}

export const updateActivity = async (fleetTaskId, activityId, data) => {
  return defaultClientV2({
    method: 'PATCH',
    baseURL,
    url: `/fleet-task/${fleetTaskId}/activity/${activityId}/timeline`,
    data,
  })
}
